import changePhoneDictionary from '@features/change-phone/i18n/ru/change-phone.dic.json';

import otpDictionary from '@entities/otp/i18n/ru/otp.dic.json';

export const otp = {
  OTP: otpDictionary,
  CHANGE_PHONE: changePhoneDictionary,
};

export const otpNamespaces = ['OTP', 'CHANGE_PHONE'];
